module.exports = __webpack_public_path__ + "img/lg_ring_g_0_1_1.126ee44f.png";